import { Colors } from '@kvika/audur-theme'
import { components, ContainerProps, DropdownIndicatorProps, GroupBase, OptionProps } from 'react-select'
import styled from 'styled-components'

import CheckBox from '../icons/CheckBox'
import CheckboxChecked from '../icons/CheckBoxChecked'
import ChevronSvg from '../icons/ChevronSvg'

import { Option } from './Constants'

export const ChevronUp = styled(ChevronSvg)`
	width: 24px;
	height: 24px;
	transform: rotate(-90deg);
	path {
		fill: ${Colors.Beige};
	}
`

export const ChevronDown = styled(ChevronSvg)`
	width: 24px;
	height: 24px;
	transform: rotate(90deg);
`

export const DropdownIndicator = (props: DropdownIndicatorProps<Option, boolean, GroupBase<Option>>) => {
	const { isDisabled, isFocused, ...rest } = props
	return (
		<components.DropdownIndicator isDisabled={isDisabled} isFocused={isFocused} {...rest}>
			{rest.selectProps.menuIsOpen ? <ChevronUp /> : <ChevronDown />}
		</components.DropdownIndicator>
	)
}

export const SelectContainer = ({
	children,
	isFocused,
	selectProps,
	...rest
}: ContainerProps<Option, boolean, GroupBase<Option>>) => {
	// @ts-ignore
	const { label, labelOnly } = selectProps

	const handleLabelClick = () => {
		if (labelOnly && selectProps.onMenuOpen) {
			selectProps.onMenuOpen()
		}
	}

	return (
		<components.SelectContainer isFocused={isFocused} selectProps={selectProps} {...rest}>
			{labelOnly ? (
				<div
					onClick={handleLabelClick}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault()
							handleLabelClick()
						}
					}}
					role='button'
					tabIndex={0}
					data-testid='audur-select-label'
				>
					{label}
				</div>
			) : (
				<StyledButtonAsLabel
					type='button'
					data-testid='audur-select-label'
					onClick={handleLabelClick}
					aria-haspopup='listbox'
				>
					{label}
				</StyledButtonAsLabel>
			)}
			{children}
		</components.SelectContainer>
	)
}

const StyledOptionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
`

const StyledButtonAsLabel = styled.button`
	display: flex;
	lineheight: 22px;
	color: Colors.Beige;
	fontweight: 400;
	fontsize: 16px;
	letterspacing: 0.5px;
	cursor: pointer;
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
`

export const OptionComponent = (props: OptionProps<Option, boolean, GroupBase<Option>>) => {
	const { label, isSelected, ...rest } = props
	return (
		<components.Option {...rest} isSelected={isSelected} label={label}>
			<StyledOptionWrapper>
				{isSelected ? <CheckboxChecked /> : <CheckBox />}
				<span>{label}</span>
			</StyledOptionWrapper>
		</components.Option>
	)
}
